import ActivityLogTable from "../components/ActivityLogTable";
import { useQueryFirmActivities } from "../lib/activity-log";
import FirmNav from "./FirmNav";

const FirmActivity = () => {
  const { isPending, isError, data } = useQueryFirmActivities();

  return (
    <>
      <FirmNav />
      <h2 className="mt-4 mb-3">Activity Log</h2>
      <ActivityLogTable
        isLoading={isPending}
        isError={isError}
        activities={data?.data ?? []}
      />
    </>
  );
};

export default FirmActivity;
